import { render, staticRenderFns } from "./map.vue?vue&type=template&id=04aa2236&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"
import style0 from "./map.vue?vue&type=style&index=0&id=04aa2236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa2236",
  null
  
)

export default component.exports